import React from "react";
import Layout from "./shared/Layout";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { projects } from "./data/project";
import classes from "./assets/css/Project.module.css";

const sliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  lazyLoad: true,
  dots: true,
  fade: true,
};

const projectData = projects();

const Projects = () => {
  return (
    <Layout>
      <div className={`projects-wrapper mt-5 ${classes.projects}`}>
        <Slider {...sliderSettings}>
                    
          {projectData.map((project) => (
            <div
              className={`${classes.flex} d-flex`}
              style={{ background: "rgba(255, 255, 255, 0.13)" }}
            >
              <div className="project-details ps-4 pe-2 pt-4 pb-3">
                <h2 className="project-title">{project.title}</h2>
                <p className="project-description">{project.description}</p>
                <a
                  className="rounded-pill"
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  VIEW MORE
                </a>
              </div>
              <div className={classes.project_image}>
                <img src={project.image} alt={project.title} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Layout>
  );
};

export default Projects;
